<template>
    <div class="container">
        <div class="nav_header">
            <h2>修改手机号码</h2>
        </div>

        <el-form ref="form" :model="form" label-width="150px" class="form" :rules="rules">
            <el-form-item label="手机号码" prop="mobile" required>
                <el-input placeholder="请输入新手机号" v-model="form.mobile"> </el-input>
            </el-form-item>

 
            <el-form-item label="短信验证码" required v-if="form.mobile">
                <el-col :span="11">
                    <el-form-item prop="captcha_sms">
                        <el-input placeholder="请输入验证码" v-model="form.captcha_sms" clearable> </el-input>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-form-item>
                        <el-button plain ref="getcaptcha" @click="getcaptcha" :disabled="countDown > 0">{{
                            countDown ? "请等待" + countDown + "秒" : "获取验证码"
                        }}</el-button>
                    </el-form-item>
                </el-col>
            </el-form-item>


            <el-form-item required>
                <div class="nc-container" id="nc-container"></div>
            </el-form-item>

            <white-space />

            <el-form-item>
                <el-button @click="submit" class="pointer" type="primary" :disabled="disabled">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            const validateMobile = (rule, value, callback) => {
                if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                    callback(new Error("手机号码格式错误"));
                } else {
                    callback();
                }
            };

            return {
                form: {
                    mobile: "",
                    captcha_sms: "",
                    scope: "mobile_reset",
                    captcha: "",
                },
                time: "",
                token: "",
                disabled: false,
                countDown: 0,
                rules: {
                    mobile: [
                        {
                            required: true,
                            message: "请输入手机号码",
                            trigger: "blur",
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur",
                        },
                    ],
                    captcha: [
                        {
                            required: true,
                            message: "请滑动验证码",
                            trigger: "blur",
                        },
                    ],
                    captcha_sms: [
                        {
                            required: true,
                            message: "请输入短信验证码",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        created() {
            this.time = 60;
            localStorage.getcode = true;
        },
        mounted() {
            //验证码
            var nc_token = ["FFFF0N0N000000008717", new Date().getTime(), Math.random()].join(":");
            var NC_Opt = {
                renderTo: "#nc-container",
                appkey: "FFFF0N0N000000008717",
                scene: "nc_login",
                token: nc_token,
                customWidth: 300,
                trans: { key1: "code0" },
                elementID: ["usernameID"],
                is_Opt: 0,
                language: "cn",
                isEnabled: true,
                timeout: 3000,
                times: 5,
                callback: (data) => {
                    this.form.captcha = data;
                    // vm.captchaSuccess = true
                },
            };
            var nc = new noCaptcha(NC_Opt);
            nc.upLang("cn", {
                _startTEXT: "请按住滑块，拖动到最右边",
                _yesTEXT: "验证通过",
                _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
            });
        },
        methods: {
            submit() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        this.$http
                            .post("auth/reset_mobile", {
                                captcha_sms: this.form.captcha_sms,
                                mobile: this.form.mobile,
                            })
                            .then((response) => {
                                if (response.success) {
                                    this.$alert("请查看手机短信验证码", "验证码发送成功", {
                                        confirmButtonText: "确定",
                                        showCancelButton: false,
                                    });
                                } else {
                                    this.$alert(response.message, "验证码发送失败", {
                                        confirmButtonText: "确定",
                                        showCancelButton: false,
                                    });
                                }
                            });
                    } else {
                        return false;
                    }
                });
            },
            getcaptcha() {
                if (this.form.mobile == "") {
                    this.$alert("手机号码不能为空", "输入错误", {
                        confirmButtonText: "确定",
                        callback: (action) => {},
                    });
                } else if (this.form.captcha == "") {
                    this.$alert("请输入图片验证码", "输入错误", {
                        confirmButtonText: "确定",
                        callback: (action) => {},
                    });
                } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.form.mobile)) {
                    this.$alert("手机号码格式错误", "输入错误", {
                        confirmButtonText: "确定",
                        callback: (action) => {},
                    });
                } else {
                    this.countDown = 60;

                    this.$http
                        .post("auth/captcha/sms", {
                            mobile: this.form.mobile,
                            scope: "mobile_verify",
                            token: this.form.token,
                            captcha: this.form.captcha,
                        })
                        .then((response) => {
                            if (response.success) {
                                this.$alert("请查看手机短信验证码", "验证码发送成功", {
                                    confirmButtonText: "确定",
                                    callback: (action) => {},
                                });

                                var timer = setInterval(() => {
                                    this.countDown--;
                                    if (this.countDown == 0) {
                                        clearInterval(timer);
                                    }
                                }, 1000);
                            } else {
                                this.countDown = 0;
                                this.$alert(response.message, "验证码发送失败", {
                                    confirmButtonText: "确定",
                                    callback: (action) => {},
                                });
                            }
                        })
                        .catch(() => {
                            this.countDown = 0;
                        });
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        .form {
            width: 460px;
        }

        .form .line {
            text-align: center;
            visibility: hidden;
        }
        .short {
            width: 200px;
            margin-right: 10px;
        }
    }
</style>
